import { Reveal } from "./Reveal";

const STEPS = [
  {
    n: "1",
    title: "Add your friends",
    body: "Build your crew and see at a glance who's free and who's already out.",
  },
  {
    n: "2",
    title: "Pull up somewhere",
    body: "Check in at a spot or send one smart invite — everyone who's down gets it instantly.",
  },
  {
    n: "3",
    title: "Meet up IRL",
    body: "Skip the group-chat chaos and actually be out with your people tonight.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="py-20 sm:py-28 px-6">
    <div className="max-w-5xl mx-auto">
      <Reveal className="text-center">
        <h2 className="font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl">
          How it works
        </h2>
        <p className="mt-4 text-base text-zinc-400 max-w-xl mx-auto">
          Three taps between sitting at home and being out with your friends.
        </p>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-3 gap-10 sm:gap-6">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1} className="text-center">
            <div data-testid={`how-step-${s.n}`}>
              <span className="inline-flex w-11 h-11 items-center justify-center rounded-full border border-[#4FE3E0]/40 bg-[#4FE3E0]/10 text-[#4FE3E0] font-semibold">
                {s.n}
              </span>
              <h3 className="mt-5 font-semibold text-white text-lg">{s.title}</h3>
              <p className="mt-2 text-sm text-zinc-400 leading-relaxed max-w-[260px] mx-auto">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
